import { Component, OnInit } from '@angular/core';
import { MilestoneService } from 'src/app/services/milestone.service';
import { Milestone } from 'src/app/model/milestone';

@Component({
  selector: 'milestone-list',
  templateUrl: 'milestone-list.html',
  styleUrls: ["milestone-list.css"]
})

export class MilestoneListComponent implements OnInit {
  
  milestones: Milestone[] = null;
  private selectedMilestone: Milestone = null;

  ngOnInit(): void {
    this.getMilestones();
  }

  constructor(private milestoneService: MilestoneService) { }
  
  getMilestones(): void {
    this.milestoneService.getMilestones().subscribe(milestones => this.milestones = milestones);
  }

  private checked(milestone: Milestone): void {
    this.selectedMilestone = milestone;
  }
}
